import API_service from "../xAppLib/providers/API_service";

export async function fetchAsBlobUrl(url) {
    if (url && !url.startsWith('/') && !url.startsWith('blob:')) {
        try {
            const apiOrigin = new URL(API_service.API_BASE_URL).origin
            if (new URL(url).origin !== window.location.origin && new URL(url).origin !== apiOrigin) {
                // if its external url return as is
                return url
            }
        } catch {}
    }
    const token = await app.user.idtoken();
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error(`Failed to load file (${res.status})`);
    return URL.createObjectURL(await res.blob());
}

/** The filename a server asked for in Content-Disposition, preferring the UTF-8 form */
export function filenameFromDisposition(header, fallback) {
    const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header ?? "")?.[1];
    const plain = /filename="?([^";]+)"?/i.exec(header ?? "")?.[1];
    const name = encoded ?? plain;

    try {
        return name ? decodeURIComponent(name) : fallback;
    } catch {
        return name ?? fallback;
    }
}

/** Replace path separators, reserved characters and control characters so a server can't pick a path */
function safeFilename(name) {
    return Array.from(name, (ch) => (ch.charCodeAt(0) < 32 || '\\/:*?"<>|'.includes(ch) ? "_" : ch)).join("");
}

/** Fetch an authenticated file and hand it to the browser as a download */
export async function downloadAsFile(url, fallbackName = "download.pdf") {
    const token = await app.user.idtoken();
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error(`Failed to download file (${res.status})`);

    const blobUrl = URL.createObjectURL(await res.blob());
    try {
        // only ever navigate to the blob we just created, and never let the server pick a path
        if (!blobUrl.startsWith("blob:")) throw new Error("Unexpected download URL");
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = safeFilename(filenameFromDisposition(res.headers.get("Content-Disposition"), fallbackName));
        document.body.appendChild(link);
        link.click();
        link.remove();
    } finally {
        URL.revokeObjectURL(blobUrl);
    }
}

async function api_file(data) {
    if (data.signed_url) {
        return data.signed_url
    }
    const url = `${API_service.API_BASE_URL}file/doc/view/${data.bct}/${encodeURIComponent(data.file_fn)}`;
    return fetchAsBlobUrl(url);
}

export default api_file;
